import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudCardModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { InsightsClariService } from 'app/services/insights-clari.service';
import { UserService } from 'app/services/user.service';

import { InsightsTiersSugestionsModule } from '../insights-tiers-sugestions/insights-tiers-sugestions.module';
import { InsightsClariSugestionsComponent } from './insights-clari-sugestions.component';

@NgModule({
	declarations: [InsightsClariSugestionsComponent],
	imports: [
		CommonModule,
		TranslateModule,
		InsightsTiersSugestionsModule,
		FreudTypographyModule,
		FreudCardModule,
	],
	exports: [InsightsClariSugestionsComponent],
	providers: [InsightsClariService, UserService],
})
export class InsightsClariSugestionsModule {}
